import React, { useState } from "react";
import {
    Mail,
    Lock,
    User,
    Phone,
    Eye,
    EyeOff
} from "lucide-react";
import { Link, useNavigate } from "react-router-dom";
import Btncom from "../Components/Btncom";
import { toast } from "react-toastify";
import reapi from "../apis/reapi";

export default function Login() {
    const [showPassword, setShowPassword] =
        useState(false);

    const [loading, setloading] = useState(false);
    window.document.title = 'Login'
    const navigate = useNavigate()

    const [formData, setFormData] = useState({
        email: "",
        password: "",
    });

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData({ ...formData, [name]: type === "checkbox" ? checked : value });
    };

    function isValidEmail(email) {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(email);
    }


    const handlebtnclick = async (e) => {
        await setloading(true)
        if (isValidEmail(formData.email) && formData.password !== '') {

            await reapi.post(`/login`, formData).then(async (res) => {
                if (res?.data.status) {
                    console.log(res.data)
                    toast.success(res?.data.message)
                    await localStorage.setItem('token', res.data.data.token);
                    await localStorage.setItem('userInfo', JSON.stringify(res.data.data.user));
                    navigate(`/`)
                    window.location.reload(``)
                } else {
                    // console.log(res.data)
                    toast.error(res?.data.message)

                }
            }).catch((e) => {

                // console.log('error respose:',e)
                toast.error(e?.response?.data.message)

            })

        } else {
            toast.error('Please Fill Correct Email and Password')

        }
        await setloading(false)
    }

    return (
        <div className="min-h-screen bg-gradient-to-br from-orange-50 via-white to-orange-100 flex items-center justify-center px-4">
            <div className="w-full max-w-md">
                {/* Logo */}
                <div className="text-center mb-8">
                    <img src="https://i.ibb.co/HTJMwrc0/crop-logo-shipless.png" width={350} style={{ textAlign: 'center', display: 'unset' }} />
                    <p className="text-gray-500 mt-2">
                        AI Powered Shipping Optimizer for Meesho Sellers
                    </p>
                </div>

                {/* Card */}
                <div className="bg-white/80 backdrop-blur-lg border border-white rounded-3xl shadow-xl p-8">
                    <h2 className="text-2xl font-bold text-gray-800">
                        Welcome back
                    </h2>

                    <p className="text-gray-500 mt-1 mb-6">
                        Login to your ShipLess account
                    </p>



                    {/* Email */}
                    <div className="mb-4">
                        <label className="text-sm font-medium">
                            Email Address
                        </label>

                        <div className="flex items-center border rounded-xl mt-2 px-3">
                            <Mail size={18} />
                            <input
                                label="Email" name="email" value={formData.email} onChange={handleChange}
                                type="email"
                                placeholder="you@example.com"
                                className="w-full p-3 outline-none"
                            />
                        </div>
                    </div>

                    {/* Password */}
                    <div className="mb-6">
                        <label className="text-sm font-medium">
                            Password
                        </label>

                        <div className="flex items-center border rounded-xl mt-2 px-3">
                            <Lock size={18} />

                            <input
                                type={
                                    showPassword
                                        ? "text"
                                        : "password"
                                }
                                label="Password" name="password" value={formData.password} onChange={handleChange}
                                placeholder="Minimum 6 characters"
                                className="w-full p-3 outline-none"
                            />

                            <button
                                type="button"
                                onClick={() =>
                                    setShowPassword(
                                        !showPassword
                                    )
                                }
                            >
                                {showPassword ? (
                                    <EyeOff size={18} />
                                ) : (
                                    <Eye size={18} />
                                )}
                            </button>
                        </div>
                    </div>

                    {/* <Link to='/forgot'>
                        <div className="flex items-end justify-end my-6 mb-8">
                            <span className="px-3 text-md text-red-400 font-bold">
                                Forgot Password?
                            </span>
                        </div>
                    </Link> */}
                    {/* Signup Button */}
                    {/* <button className="w-full bg-orange-500 hover:bg-orange-600 text-white font-semibold py-3 rounded-xl transition">
                        Login
                    </button> */}

                    <Btncom onClick={handlebtnclick} loading={loading} title={'Login'} />

                    {/* Divider */}
                    <div className="flex items-center my-6">
                        <div className="flex-1 border-t"></div>
                        <span className="px-3 text-sm text-gray-400">
                            New to ShipLess?
                        </span>
                        <div className="flex-1 border-t"></div>
                    </div>

                    {/* Login */}
                    <Link to='/signup'>
                        <button className="w-full border border-[#551cd1] text-[#551cd1] py-3 rounded-xl hover:bg-orange-50 transition">

                            Create a account →

                        </button>
                    </Link>
                    {/* <p className="text-center text-xs text-gray-500 mt-6">
            By creating an account you agree to
            Terms & Privacy Policy
          </p> */}
                </div>
            </div>
        </div>
    );
}